import { useState, useMemo, useRef } from 'react';
import { ScrollSyncPane } from 'react-scroll-sync';

import { StyledSummaryEditElement } from '../../../atoms/SummaryEditElement/StyledSummaryEditElement';
import { StyledSavePayElement } from '../../../atoms/PayElement/StyledSavePayElement';
import { StyledClosePayElement } from '../../../../styles/sharedStyles';

import CloseIcon from '../../../atoms/UserPanelStudens/CloseIcon';
import PencilIcon from '../../../atoms/UserPanelStudens/PencilIcon';
import AcceptIcon from '../../../atoms/UserPanelStudens/AcceptIcon';
import { getString } from '../../../../strings';
import SummaryEditElementManagerHourTable from './SummaryEditElementManagerHourTable';
import DeleteManagerHourPopup from './DeleteManagerHourPopup';
import { handleDelete, handleSubmit } from './SummaryEditManagerHour.data';
import SummaryEditManagerHourEditableTable from './SummaryEditManagerHourEditableTable';

const SummaryEditManagerHourElement = ({
    hour,
    setHour,
    deleteHour,
    managers,
    managerHourTypes,
}) => {
    const [isEdit, setIsEdit] = useState(false);
    const [confirmPopup, setConfirmPopup] = useState(false);

    const defaultValues = useMemo(
        () => ({
            type: hour.type.id,
            date: new Date(hour.date).toISOString().split('T')[0],
            hours: hour.hours,
            manager: hour.manager.id,
            price: hour.price,
            description: hour.description,
        }),
        [hour]
    );

    const values = {
        type: useRef(),
        date: useRef(),
        hours: useRef(),
        manager: useRef(),
        price: useRef(),
        description: useRef(),
    };

    return (
        <>
            <DeleteManagerHourPopup
                confirmPopup={confirmPopup}
                setConfirmPopup={setConfirmPopup}
                hour={hour}
                handleDelete={() =>
                    handleDelete(hour.id, deleteHour, confirmPopup, setConfirmPopup)
                }
                getString={getString}
            />
            <StyledSummaryEditElement>
                <ScrollSyncPane>
                    <div>
                        {!isEdit ? (
                            <SummaryEditElementManagerHourTable hour={hour} />
                        ) : (
                            <SummaryEditManagerHourEditableTable
                                defaultValues={defaultValues}
                                values={values}
                                managers={managers}
                                managerHourTypes={managerHourTypes}
                            />
                        )}
                    </div>
                </ScrollSyncPane>
                <StyledSavePayElement
                    isedit={isEdit}
                    onClick={
                        isEdit
                            ? () =>
                                  handleSubmit(
                                      hour.id,
                                      Object.fromEntries(
                                          Object.entries(values).map(([key, ref]) => [
                                              key,
                                              ref.current.value,
                                          ])
                                      ),
                                      (newHour) => {
                                          setIsEdit(false);
                                          setHour((hour) => ({
                                              ...hour,
                                              ...newHour,
                                          }));
                                      }
                                  )
                            : () => setIsEdit(true)
                    }
                >
                    {!isEdit ? <PencilIcon /> : <AcceptIcon />}
                </StyledSavePayElement>
                <StyledClosePayElement
                    onClick={() => (isEdit ? setIsEdit(false) : setConfirmPopup(true))}
                >
                    <CloseIcon />
                </StyledClosePayElement>
            </StyledSummaryEditElement>
        </>
    );
};

export default SummaryEditManagerHourElement;
